import { gql } from '@apollo/client'

export const DELETE_ROOMTYPE = gql`
  mutation DeleteRoomType($input: DeleteRoomTypeInput!) {
    deleteRoomType(input: $input) {
      message
    }
  }
`
